export const autoFill = ({value, setearValor, num, name}) => {
    const numCeros = value.replace(/^(0+)/g, '').padStart(num, '0');
    const newValue = numCeros.slice(0, num);
    setearValor(name, newValue);
}

export const autoFillReturn = (value, num) => {
    const numCeros = value.replace(/^(0+)/g, '').padStart(num, '0');
    const newValue = numCeros.slice(0, num);
    return newValue;
}